import { type LinearConfiguratorState } from "../redux/types";
import { type LinearConfiguration } from "../models";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";

export function sendLinearStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";

  return sendLinear(data);
}

export function sendLinearMiscChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);

  data.cpqAction = "TOGGLE_GROUP";

  return sendLinear(data);
}
